import authWrapper from '@components/01.base/auth-wrapper/auth-wrapper.vue'
import Carousel from './carousel/carousel'
import ShareIcons from './share-icons/share-icons'
import FlippingCard from './flipping-card/flipping-card'
import FomoPasswordProtect from './fomo-password-protect/fomo-password-protect'
import FomoPasswordForm from './fomo-password-protect/fomo-password-form'
import AccordionTab from './accordion-tab/accordion-tab'
import ToggleDetails from './toggle-details/toggle-details'
import LoadingDots from './loading-dots/loading-dots'
import LanguageSwitcher from './language-switcher/language-switcher'
import Modal from './modal/modal'
import ExternalLinkModal from './external-link-modal/external-link-modal'
import Overlay from './overlay/overlay'
import Slider from './slider/slider'
import TabTrap from './tab-trap/tab-trap'
import VideoPlayer from './video-player/video-player'
import Tabs from './tabs/tabs'
import GoogleMap from './map/google-map.vue'
import Gallery from './gallery/gallery'
import SecondaryNav from './secondary-nav/secondary-nav'
import Olapic from './olapic/olapic'
import TrackData from './track-data/track-data'
import AccessibleTabs from './accessible-tabs/accessible-tabs'
import GenericSearch from './generic-search/generic-search'
import Alert from './alert/alert'
import MapFilter from './map-filter/map-filter'
import DashboardCarousel from './dashboard-carousel/dashboard-carousel'
import AddToCalendar from './add-to-calendar/add-to-calendar'
import GreetingSignIn from './greeting-sign-in/greeting-sign-in'
import Experiences from './experiences/experiences'
import Menu from './menu/menu-grid.vue'
import UpcomingEvents from './upcoming-events/upcoming-events'
import filteredTab from './filtered-tab/filtered-tab.vue'
import BaseCard from '../../../../../fanclub/03.javascript/vue/components/01.base/base-card/base-card.vue'
import TabFilter from '../../../../../fanclub/03.javascript/vue/components/01.base/tab-filter/tab-filter.vue'
import BaseIcon from '../../../../../fanclub/03.javascript/vue/components/01.base/base-icon/base-icon.vue'
import carouselConverter from './carousel-converter/carousel-converter.vue'
import alertMessage from './alert-message/alert-message.vue'
import AccordionDark from './accordion-dark/accordion-dark'
import BookButton from './book-button/book-button'

// Group components
import * as Forms from './01.forms'
import * as Lists from './02.lists'
import * as SidebarNav from './03.sidebar'
import * as Header from './04.header'

export const {
  SitecoreForm,
  FilteringForm,
  DateFieldInput,
  PhoneCountrySelect
} = Forms

export const {
  SimpleList,
  LoadMorePagination,
} = Lists

export const {
  SidebarLinks,
  NavButtonToggle,
} = SidebarNav

export const {
  HeaderMain,
  StickyHeader
} = Header

export {
  authWrapper,
  Carousel,
  ShareIcons,
  FlippingCard,
  FomoPasswordProtect,
  FomoPasswordForm,
  AccordionTab,
  ToggleDetails,
  LoadingDots,
  LanguageSwitcher,
  Modal,
  ExternalLinkModal,
  Overlay,
  Slider,
  TabTrap,
  VideoPlayer,
  Tabs,
  Gallery,
  GoogleMap,
  SecondaryNav,
  Olapic,
  TrackData,
  AccessibleTabs,
  GenericSearch,
  Alert,
  MapFilter,
  DashboardCarousel,
  GreetingSignIn,
  AddToCalendar,
  Experiences,
  Menu,
  filteredTab,
  BaseCard,
  TabFilter,
  BaseIcon,
  UpcomingEvents,
  carouselConverter,
  alertMessage,
  AccordionDark,
  BookButton,
}
